interface DocumentSigningIconProps {
  className?: string
}

export function DocumentSigningIcon({
  className = 'w-8 h-10',
}: DocumentSigningIconProps) {
  return (
    <div
      className={`bg-primary-50 rounded-xl border-4 border-primary-200 relative ${className}`}
    >
      {/* Document corner fold */}
      <div className='absolute top-0 right-0 w-3 h-3 bg-white border-l-2 border-b-2 border-primary-200'></div>

      {/* Document content lines */}
      <div className='mt-2 mx-1 space-y-0.5'>
        <div className='h-1 bg-blue-500 rounded w-full'></div>
        <div className='h-1 bg-blue-500 rounded w-3/4'></div>
        <div className='h-1 bg-blue-500 rounded w-full'></div>
        <div className='h-1 bg-blue-500 rounded w-1/2'></div>
      </div>

      {/* Signature line with pen animation */}
      <div className='absolute bottom-2 left-2 right-2'>
        <div className='h-1 bg-primary-300 rounded relative overflow-hidden'>
          <div className='absolute inset-0 bg-blue-500 rounded animate-pulse'></div>
        </div>
        <svg
          className='absolute -right-1 -top-6 text-blue-500 animate-bounce w-6 h-6'
          fill='currentColor'
          viewBox='0 0 512 512'
        >
          <path d='M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z' />
        </svg>
      </div>
    </div>
  )
}
